import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import { ButtonBar, ScreenHeader } from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOAGiftsIntro() {
  const { powerOfAttorney, setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  const [ allowGifts, setAllowGifts ] = useState(powerOfAttorney.allow_gifts || false);
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('../government-benefits');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      allow_gifts: allowGifts
    }));
    
    navigate('../gifts-to-agent');
  }, [ allowGifts, setPowerOfAttorney, navigate ]);
  
  return (
    <div className="new-poa-gifts-intro screen-container screen">
      <ScreenHeader
        title="Making Gifts"
        description="Decide whether to allow your agent to make gifts on your behalf"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>What Are Gift Powers?</h3>
        <p>
          Gift powers allow your agent to make gifts of your money or property to other people 
          or organizations. This can be useful for:
        </p>
        <ul className="gift-benefits">
          <li>Annual gift tax exclusion planning</li>
          <li>Supporting family members in need</li>
          <li>Making charitable donations</li>
          <li>Estate tax planning strategies</li>
        </ul>

        <h3>Important Considerations</h3>
        <ul className="gift-considerations">
          <li>Gifts reduce your estate and may have tax implications</li>
          <li>You can set limits on the amount and recipients of gifts</li>
          <li>Gifts to your agent may have special restrictions</li>
          <li>Some states have specific rules about gift powers</li>
        </ul>

        <h3>Do You Want to Allow Your Agent to Make Gifts?</h3>
        <div className="gift-options">
          <div className={`option-card ${!allowGifts ? 'selected' : ''}`}>
            <label className="option-label">
              <input
                type="radio"
                name="allow-gifts"
                checked={!allowGifts}
                onChange={() => setAllowGifts(false)}
              />
              <div className="option-content">
                <h4>No</h4>
                <p>Do not allow my agent to make gifts on my behalf</p>
              </div>
            </label>
          </div>

          <div className={`option-card ${allowGifts ? 'selected' : ''}`}>
            <label className="option-label">
              <input
                type="radio"
                name="allow-gifts"
                checked={allowGifts}
                onChange={() => setAllowGifts(true)}
              />
              <div className="option-content">
                <h4>Yes</h4>
                <p>Allow my agent to make gifts with the restrictions I specify</p>
              </div>
            </label>
          </div>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
